import React, { Component } from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Container from 'react-bootstrap/Container'
import { dataSource, initRemDb, initMem } from '../services/dataSource'
import { getLocal} from '../services/storage'
// import { checkToken, login } from '../services/network'
// import {sleep} from '../shared/utils'
import { isBeta } from '../services/network';

window._ms_dataSource = dataSource

export class Preloader extends Component {

  constructor(props) {
    super(props)
    // console.log('preloader constructor with props', props)
    props.setTitle('Loading . . .')
    this.state = {
      progress: 0,
      msg: 'Progress...',
      allDataRefs: {},
      progressCallBack: this.progressCallBack.bind(this)
    }
  }

  async componentDidMount() {
    const {token} = await getLocal('user')
    // const user = await getLocal('user')
    const beta = await isBeta()
    const skipCheck = await getLocal('skipCheck')
    let b = false
    if (beta === "true") b = true
    // console.log('attempting init dbs', token, beta, window.process.env.APP_URL)
    initMem()
    // initDb()
    initRemDb({ token }, b)
    const { props} = this
    // const { progressCallBack } = state
    const { displayNotif, diagnostics, navigate} = props
    console.log('preloader with skipCheck', skipCheck, diagnostics)

    try {
      let online = diagnostics.getOnlineStatus()
      // await this.attemptLogin(online)
      if (online && !skipCheck) {
        console.log('doing checkPutAll')
        // await sleep(250)
      } else {
        displayNotif('You are offline. You will not be able to make edits.', 'danger')
      }
      navigate('/home')

    } catch (e) {
      console.log(e)
      displayNotif(e.message, 'warning')
    }
  }


  



  progressCallBack(progress, msg) {
    this.setState({ progress, msg })
  }

  render() {
    let { state } = this
    return (
      <Container>
        <h4>{state.msg}</h4>
        <ProgressBar
          animated
          variant="info"
          now={state.progress}
        />
      </Container>
    )
  }

}
